import React from 'react'
import { Link } from 'react-router'

import './RescheduleConfirmNavBar.scss'
import ProfileMobileNavBar from 'components/ProfileMobileNavBar'

const RescheduleConfirmNavBar = ({ goBack }) => {
  return (
    <ProfileMobileNavBar back>
      Confirmar cambios
    </ProfileMobileNavBar>
  )
}

RescheduleConfirmNavBar.displayName = 'RescheduleConfirmNavBar'

export default RescheduleConfirmNavBar



// WEBPACK FOOTER //
// ./src/screens/App/screens/Services/screens/RescheduleConfirm/components/RescheduleConfirmNavBar/RescheduleConfirmNavBar.js